module.exports = __webpack_public_path__ + "img/more_off.9abb5fef.svg";